import YetiClient from "./YetiClient";

const YetiDocuments = {
  /**
   * Get documenttype list
   *
   * Returns a list of document types EX: GUIDE, PORTAL, PORTAL_DOWNLOAD, etc.
   * @returns {Object}
   */
    async getDocumentTypeList() {
      return YetiClient.getPaginated("/documents/documenttypelist");
    },

  /**
   * Get document list
   *
   * @param {string} context
   * @param {string} context_id
   * @param {string} type
   * @returns {Object}
   */
  async getDocumentList(type, context="", context_id="") {
    const params = {
      context: context,
      context_id: context_id,
      type: type
    };
    return YetiClient.getPaginated("/documents/documentlist", {
      params: params
    });
  },

  /**
   * Get document and stream it to browser.
   *
   * @param {string} document_id
   * @returns {Object}
   */
    async downloadDocument(document_id) {
      const response = await YetiClient.get(`/documents/document?document_id=${document_id}`, {
        headers: { Accept: "application/octet-stream"}
      });
      return { data: response.data || '' }; // Lambda response is already base64 encoded
      // return { data: Buffer.from((response.data || ''), 'binary').toString('base64')}; // This would only be necessary if the Lambda was returning binary
    },

    /**
   * Get document by document_id.
   *
   * @param {string} document_id
   * @returns {Object}
   */
    async getDocument(document_id) {
      return YetiClient.get(`/documents/document?document_id=${document_id}`);
    }
};

export default YetiDocuments;
